import React, { useState, useRef } from "react";
import { useObserver } from "mobx-react";
import { uploadFileToAzure } from "../../../services/azure";
import { useNavigate } from "react-router-dom";
import { apiPostPut } from "../../../api/api_methods";
import { useStores } from "../../../store";
import { AiOutlineShareAlt } from "react-icons/ai";
import JobShare from "../Components/Job";
import { getDomainForWhiteLabeling } from "../../../services/white_label";
import office from "../../../assests/office-building.png";
import { PopupForUploadResume } from "./HR";
import { pdfjs } from "react-pdf";
import axios from "axios";
import Popup from "../../reusble_components/popup";
import { loginWarningImage } from "../../../helpers/constantVariables";
import { setDataToLocalStorage } from "../../../services/localStorage";
const ActionButtons = ({ onApply, jobTitle, company, jobPostId }) => {
  const [showResumeCard, setShowResumeCard] = useState(false);
  const [resume, setResume] = useState(null);
  const [resumeText, setResumeText] = useState(null);
  const [selectedResume, setSelectedResume] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showLoginWarning, setShowLoginWarning] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const fileInputRef = useRef(null);
  const { CommonStore, RecuiterStore, PopupStore } = useStores();
  const navigate = useNavigate();

  const handleApplyForJob = async () => {
    if (localStorage.getItem("resumeText")) {
      setResumeText(localStorage.getItem("resumeText"));
    }

    if (localStorage.getItem("user") === null) {
      return setShowLoginWarning(true);
    }
    console.log("handleApplyForJob");

    if (!resume) {
      setShowResumeCard(true);
      return;
    }

    const res = await fetchData(resume);
    if (!res || resumeText?.length < 5) {
      return alert("Please upload a valid resume");
    }

    const userDetails = JSON.parse(localStorage.getItem("user"));
    const userId = userDetails?._id;

    const data = {
      userId: userId,
      jobPostId: jobPostId,
      resume: resume,
      resumeContent: resumeText,
    };

    try {
      setLoading(true);
      const apiResponse = await apiPostPut(
        data,
        "/application/new-application",
        "POST"
      );
      setLoading(false);

      if (apiResponse.status === 200) {
        alert("Application submitted successfully");
        setShowResumeCard(false);
        RecuiterStore.fetchJobApplications();
        PopupStore.setVideoPopup(true);
        CommonStore.setBottomNavigationIndex(12);
        navigate("/dashboard/myapplicants");
      } else {
        alert(apiResponse?.body?.message);
        if (
          apiResponse?.body?.message ===
          "You have already applied for this job. Please check Applications page"
        ) {
          navigate("/dashboard/myapplicants");
        }
      }
    } catch (error) {
      alert("Failed to submit application");
      console.error("Error submitting application:", error);
    }
  };

  const handleFileChange = async (e) => {
    try {
      const res = await handleResumeText(e);
      if (res.length < 5) {
        handleDelete();
        return alert("Please upload a valid resume");
      }

      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = randomNumber + timestamp;

      setSelectedResume(e.target.files[0]);
      setLoading(true);

      const fileUploaded = await uploadFileToAzure(
        filename,
        e.target.files[0],
        { action: "resume" }
      );

      const stringifiedURL = JSON.stringify(fileUploaded.url);
      localStorage.setItem("resume", stringifiedURL);
      setResume(fileUploaded.url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data;
      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      localStorage.setItem("resumeText", fullText);
      return fullText;
    } catch (error) {
      console.error("Error fetching or parsing PDF file", error);
      return "";
    }
  };

  const handleResumeText = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileURL = URL.createObjectURL(selectedFile);
      return fetchData(fileURL);
    }
  };

  const handleDelete = () => {
    setResume(null);
    setSelectedResume(null);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const file = event.dataTransfer.files[0];
    if (file) {
      fileInputRef.current.files = event.dataTransfer.files;
      handleFileChange({ target: fileInputRef.current });
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const link = () => {
    if (!jobPostId) {
      return {
        jobPostLink: "Job ID not available yet",
        clientLink: "Job ID not available yet",
      };
    }

    let jobPostLink =
      getDomainForWhiteLabeling() === "app.reaidy.io"
        ? `https://reaidy.io/job/${jobPostId}`
        : `https://${getDomainForWhiteLabeling()}/jobpost/${jobPostId}`;
    let clientLink = `https://${getDomainForWhiteLabeling()}/share/job-applicants/${jobPostId}`;
    return { jobPostLink, clientLink };
  };

  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/`;

    console.log(signupUrl);

    navigate(signupUrl);
  };

  return (
    <>
      <Popup
        popUpInitialValue={showLoginWarning}
        handlePopup={() => {
          setShowLoginWarning(false);
        }}
        image={loginWarningImage}
        content="Please signup to apply for job"
        buttontext="Signup now"
        onClick={() => {
          redirectToSignupPageWithCurrentUrl();
          setShowLoginWarning(false);
        }}
        fileInputRef={fileInputRef}
      />
      <div className="flex items-center gap-4">
        <button
          className="p-3 rounded-lg hover:bg-gray-200 transition-colors"
          onClick={() => setShowSharePopup(true)}
        >
          <AiOutlineShareAlt className="w-6 h-6" />
        </button>
        <button
          onClick={handleApplyForJob}
          className={`bg-black text-white px-8 py-3 rounded-lg ${
            JSON.parse(localStorage.getItem("user"))?.role?.role ===
              "company" && "cursor-not-allowed"
          } hover:bg-gray-800 transition-colors whitespace-nowrap`}
          disabled={
            JSON.parse(localStorage.getItem("user"))?.role?.role === "company"
          }
        >
          Apply for Job
        </button>
      </div>

      <PopupForUploadResume
        popUpInitialValue={showResumeCard}
        handlePopup={() => setShowResumeCard(false)}
        // buttontext="Upload Resume"
        onClick={handleFileChange}
        onDelete={handleDelete}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        resumeName={selectedResume?.name}
        selectFile={() => fileInputRef.current.click()}
        applyJob={handleApplyForJob}
        loading={loading}
        fileInputRef={fileInputRef}
      />

      <JobShare
        isPopupVisible={showSharePopup}
        handlePopUpVisible={setShowSharePopup}
        link={link()}
        emailSubject={"Check out this job posting!"}
        emailBody={"Here's a job link you might be interested in: "}
      />
    </>
  );
};

const BasicDetails = ({
  forJobPost,
  isSalaryDisclosed,
  showAlert,
  jobId,
  jobTitle,
  company,
  salaryRange,
  experience,
  time,
  mode,
  openings,
  location,
  jobDescription,
  responsibilities,
  requiredSkills,
  companyLogo,
  onEdit,

  jobPostId,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState({
    jobTitle,
    company,
    salaryRange,
    experience,
    location,
    jobDescription,
    responsibilities,
    requiredSkills,
    companyLogo,
    openings,
  });

  const [resume, setResume] = useState(null);
  const [selectedResume, setselectedResume] = useState(null);
  const [showResumeCard, setShowResumeCard] = useState(false);
  const fileInputRef = useRef(null);
  const [loading, setloading] = useState(false);
  const [showLoginWarning, setshowLoginWarning] = useState(false);
  const { CommonStore, RecuiterStore } = useStores();

  const handleApplyForJob = async () => {
    if (localStorage.getItem("user") === null) {
      return setshowLoginWarning(true);
    }

    if (!resume) {
      setShowResumeCard(true);
      return alert("Please upload your resume to apply job");
    }

    const userDetails = JSON.parse(localStorage.getItem("user"));
    const userId = userDetails?._id;
    const data = {
      userId: userId,
      jobPostId: jobPostId,
      resume: resume,
    };
    console.log(data);
    try {
      setloading(true);
      const apiResponse = await apiPostPut(
        data,
        "/application/new-application",
        "POST"
      );
      setloading(false);
      if (apiResponse.status === 200) {
        alert("Application submitted successfully");
        // scrollToTop();
        navigate("/dashboard/myapplicants");

        // Set bottom navigation index
        CommonStore.setBottomNavigationIndex(12);
      } else {
        alert(apiResponse?.body?.message);
      }
    } catch (error) {
      alert("Failed to submit application");
      console.error("Error submitting application:", error);
    } finally {
      // setApplying(false);
    }
  };
  const handleFileChange = async (e) => {
    try {
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = randomNumber + timestamp;
      setselectedResume(e.target.files[0]);
      setloading(true);
      const fileUploaded = await uploadFileToAzure(
        filename,
        e.target.files[0],
        { action: "resume" }
      );
      setloading(false);

      const stringifiedURL = JSON.stringify(fileUploaded.url);
      localStorage.setItem("resume", stringifiedURL);
      setResume(fileUploaded.url);
      // setApplying(true);

      console.log(fileUploaded.url);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleMode = () => {
    if (mode === "workFromOffice") {
      return "work from office";
    } else if (mode === "workFromHome") {
      return "work from home";
    } else {
      return "hybrid";
    }
  };

  const navigate = useNavigate();

  const handleSave = () => {
    setIsEditing(false);
    onEdit(editedData);
  };
  function decodeHtmlDouble(html) {
    if (!html) return "";
    const parser = new DOMParser();

    // First decode
    const firstDecode = parser.parseFromString(html, "text/html")
      .documentElement.textContent;

    // Second decode (to handle double-escaped entities)
    const secondDecode = parser.parseFromString(firstDecode, "text/html")
      .documentElement.textContent;

    return secondDecode;
  }

  const processJobDescription = (html) => {
    if (!html) return "";
    // If HTML is escaped, decode it
    if (
      html.includes("&lt;") ||
      html.includes("&gt;") ||
      html.includes("&amp;")
    ) {
      const parser = new DOMParser();
      const decoded = parser.parseFromString(html, "text/html").documentElement
        .textContent;
      return decoded;
    }
    return html;
  };

  const [descriptionLength, setDescriptionLength] = useState(250);

  return useObserver(() => (
    <>
      {showAlert && (
        <div className="flex flex-col md:flex-row items-center justify-between lg:ml-[3%]">
          {/* <div className="flex flex-row justify-center text-sm md:text-base text-[#EDAD07] pl-4">
            <GoAlertFill className="-mt-2 h-8 w-8" />
            <p className="pl-3">
              Make sure that you complete the interview process (all mentioned
              fields) within 24 hours of applying for the job
            </p>
          </div> */}
        </div>
      )}

      <div className="container mx-auto">
        <div className="bg-gray-100 rounded-t-2xl w-full p-3 sm:p-4 md:p-6 flex flex-col md:flex-row items-start md:items-center justify-between sticky top-0 z-10 shadow-md">
          <div className="flex flex-col w-full md:w-auto">
            <div className="flex items-start">
              <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-20 md:h-20 rounded-lg overflow-hidden flex items-center justify-center bg-white shadow-sm p-2 flex-shrink-0">
                <img
                  src={companyLogo ?? office}
                  alt={`${company} Logo`}
                  className="object-contain h-full w-full"
                />
              </div>
              <div className="ml-3 sm:ml-4 md:ml-6 ">
                <div className="flex-grow">
                  <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-orange-500 mb-1 sm:mb-2">
                    {jobTitle}
                  </h1>
                  <p className="text-xs sm:text-sm text-gray-700 mb-2">
                    {JSON.parse(localStorage.getItem("user"))?.companyName}
                  </p>
                </div>
                <div className="mt-3 w-full flex flex-col">
                  <div className="flex flex-wrap gap-1.5 sm:gap-2">
                    {isSalaryDisclosed && <span className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-gray-200 text-gray-700 shadow-sm">
                      {salaryRange}
                    </span>}
                    <span className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-gray-200 text-gray-700 shadow-sm">
                      {time.charAt(0).toUpperCase() + time.slice(1)}
                    </span>
                    <span className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-gray-200 text-gray-700 shadow-sm">
                      {location[0]}
                    </span>
                    <span className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-gray-200 text-gray-700 shadow-sm">
                      {handleMode()}
                    </span>
                    <span className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-gray-200 text-gray-700 shadow-sm">
                      {openings} Openings
                    </span>
                    <span className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-gray-200 text-gray-700 shadow-sm">
                      {experience} Years Experience
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!forJobPost && (
            <div className="mt-4 md:mt-0 w-full md:w-auto">
              <ActionButtons
                onApply={handleApplyForJob}
                jobTitle={jobTitle}
                company={company}
                jobPostId={jobPostId}
              />
            </div>
          )}
        </div>
        <div className="mt-6 mx-4 border-b-2 pb-5">
          <style>{`
            .job-description-content h3 {
              font-size: 1.125rem;
              font-weight: 600;
              margin-top: 1.5rem;
              margin-bottom: 0.75rem;
              color: #1f2937;
            }
            .job-description-content h3:first-child {
              margin-top: 0;
            }
            .job-description-content p {
              margin-bottom: 1rem;
              color: #374151;
              line-height: 1.625;
            }
            .job-description-content ul {
              list-style-type: disc;
              margin-left: 1.5rem;
              margin-bottom: 1rem;
              padding-left: 0;
            }
            .job-description-content li {
              margin-bottom: 0.5rem;
              color: #374151;
              line-height: 1.625;
            }
            .job-description-content strong {
              font-weight: 600;
              color: #1f2937;
            }
          `}</style>
          <div className="md:ml-4">
            <h4 className="text-md  md:text-lg font-semibold mb-2">
              Job description :
            </h4>
            {(() => {
              const decodedDescription = jobDescription;

              const containsHtml = /<[^>]+>/g.test(decodedDescription);

              console.log("ORIGINAL:", jobDescription);
              console.log("DECODED:", decodedDescription);

              return containsHtml ? (
                <div
                  className="text-gray-700 mb-4 w-full break-words
      [&>h2]:text-xl [&>h2]:font-bold [&>h2]:mt-4 [&>h2]:mb-2
      [&>h3]:text-lg [&>h3]:font-semibold [&>h3]:mt-3 [&>h3]:mb-2
      [&>h4]:text-base [&>h4]:font-semibold [&>h4]:mt-2 [&>h4]:mb-1
      [&>p]:mb-3 [&>p]:leading-relaxed
      [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:mb-3 [&>ul>li]:mb-1
      [&>a]:text-primary [&>a]:underline [&>a]:hover:text-primary-dark"
                  dangerouslySetInnerHTML={{ __html: decodedDescription }}
                />
              ) : (
                <p className="text-gray-700 mb-4 w-full break-words whitespace-pre-wrap">
                  {decodedDescription}
                </p>
              );
            })()}
          </div>
          <div className=" md:mx-4">
            <h4 className="text-md md:text-lg font-semibold mb-2">
              Skills required :
            </h4>
            <div className="flex flex-wrap gap-6">
              {requiredSkills.map((skill, index) => (
                <span
                  key={index}
                  className="px-8 py-2 bg-gray-200 rounded-full text-sm text-gray-800 inline-block"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>

        {(() => {
          try {
            const startDate =
              RecuiterStore?.jobPostDetails?.customSettings?.find(
                (setting) => setting.name === "startDate"
              )?.value ||
              RecuiterStore?.jobPostDetails?.basicJobDetails?.startDate;

            if (!startDate) return null;

            const date = new Date(startDate);
            if (isNaN(date.getTime())) return null;

            return (
              <div className="flex flex-col md:mx-8 mx-4 mt-5 gap-6 mb-3">
                <div className="space-y-6">
                  <h2 className="text-2xl font-semibold">
                    Assessment Schedule Time
                  </h2>

                  <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
                    <div className="flex items-center gap-2">
                      <span className="text-gray-600 font-medium">
                        Start Date:
                      </span>
                      <span className="text-gray-800">
                        {date.toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-gray-600 font-medium">
                        End Date:
                      </span>
                      <span className="text-gray-800">
                        {(() => {
                          try {
                            const endDate =
                              RecuiterStore?.jobPostDetails?.customSettings?.find(
                                (setting) => setting.name === "endDate"
                              )?.value ||
                              RecuiterStore?.jobPostDetails?.basicJobDetails
                                ?.endDate;

                            if (!endDate) return "Not specified";

                            const endDateObj = new Date(endDate);
                            return isNaN(endDateObj.getTime())
                              ? "Not specified"
                              : endDateObj.toLocaleDateString("en-GB", {
                                  day: "numeric",
                                  month: "short",
                                  year: "numeric",
                                });
                          } catch (error) {
                            return "Not specified";
                          }
                        })()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          } catch (error) {
            return null;
          }
        })()}
      </div>
    </>
  ));
};

export default BasicDetails;
